import { Link } from "react-router-dom";
import BrandLogo from "@/components/feature/BrandLogo";
import { useMode } from "@/context/ModeContext";
import { BRAND } from "@/lib/brand";

const columns = [
  {
    title: "作品を探す",
    links: [
      { href: "/ranking", label: "ランキング" },
      { href: "/new", label: "新着作品" },
      { href: "/genres", label: "ジャンル一覧" },
      { href: "/search", label: "検索結果" },
      { href: "/advanced-search", label: "詳細検索" },
    ],
  },
  {
    title: "機能",
    links: [
      { href: "/discover", label: "好み診断" },
      { href: "/compare", label: "作品比較" },
      { href: "/favorites", label: "お気に入り" },
      { href: "/watch-later", label: "あとで見る" },
      { href: "/articles", label: "特集記事" },
    ],
  },
  {
    title: "サイト情報",
    links: [
      { href: "/about", label: "このサイトについて" },
      { href: "/contact", label: "お問い合わせ" },
      { href: "/settings", label: "設定・保存データ" },
      { href: "/privacy", label: "プライバシーポリシー" },
      { href: "/terms", label: "利用規約" },
      { href: "/disclosure", label: "広告掲載について" },
    ],
  },
  {
    title: "更新履歴",
    links: [
      { href: "/new", label: "新着・更新情報" },
      { href: "/articles", label: "編集部コラム" },
      { href: "/ranking", label: "集計について" },
    ],
  },
];

export default function SiteFooter() {
  const { mode } = useMode();

  return (
    <footer className="mt-16 border-t border-background-300 bg-background-200">
      <div className="page-container py-10 md:py-12">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-[1.5fr_repeat(4,1fr)]">
          <div>
            <BrandLogo />
            <p className="mt-4 max-w-sm text-[13px] leading-6 text-foreground-700">{BRAND.concept}</p>
            <p className="mt-2 max-w-sm text-[12px] leading-6 text-foreground-500">
              現在はデモデータで運用しており、掲載作品はすべて架空のものです。
              実在する作品・サービスとは関係ありません。
            </p>
            <p className="mt-3 inline-flex items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-2.5 py-1 text-[11px] text-foreground-600">
              <i className="ri-information-line" aria-hidden="true" />
              表示中：{mode === "female" ? "女性向け" : "男性向け"}モード
            </p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h2 className="text-[12px] font-bold tracking-wide text-foreground-900">{column.title}</h2>
              <ul className="mt-3 space-y-2">
                {column.links.map((link) => (
                  <li key={`${column.title}-${link.label}`}>
                    <Link
                      to={link.href}
                      className="text-[13px] text-foreground-600 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300 pt-6 text-[12px] text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>{BRAND.copyright} / 掲載情報はデモです。実在する作品・サービスとは関係ありません。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <Link to="/privacy" className="hover:text-primary-700">
              プライバシー
            </Link>
            <Link to="/terms" className="hover:text-primary-700">
              利用規約
            </Link>
            <Link to="/disclosure" className="hover:text-primary-700">
              広告表記
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}